
import redStripOne from '@/assets/img/red_strip_one.png'
import redStripTwo from '@/assets/img/red_strip_two.png'
import arrowRightTwo from '@/assets/img/arrow_right_two.png'
export default {
  props: {
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
    isJapan: {
      type: Boolean,
      default: () => {
        return true
      },
    },
  },
  data() {
    return {
      redStripOne,
      redStripTwo,
      arrowRightTwo,
    }
  },
  computed: {
    site() {
      return this.$route.params.site
    },
    isJp() {
      return this.site === 'jp'
    },
  }
}
